/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";

export default {
    name: "devicecontrollers",
    components: {
        VPagination,
    },
    data() {
        return {
            deviceList: [],
            currentPageNumber: 1,
            totalPages: 1,
            totalCount: 0,
            totalItems: 0,
            pageSize: 13,
            searchText: "",
            searchDeviceName: "",
            searchName: "",
            baseurl: process.env.VUE_APP_Service_URL,
            defaultdate: "",
            SortProperty: "dateTime",
            SortOrder: 1,
            showLoading:false
        };
    },
    async mounted() {
          this.defaultdate = localStorage.getItem("dateformat");
          this.defaultTime = localStorage.getItem("timeformat") ? localStorage.getItem("timeformat") : "hh:mma";
        await this.getDeviceDetails();
    },
    methods: {
        async getDeviceDetails() {
             this.showLoading=true
            const idtoken = store.getters.getIdToken;
            await axios
            .get(
                `${this.baseurl}/account-core/user/getdevicedetails`, {
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
                params: {
                    pageindex: this.currentPageNumber,
                    pagesize: this.pageSize,
                    email: this.searchText.trim(),
                    userName:this.searchName.trim(),
                    deviceName: this.searchDeviceName.trim(),
                    SortOrder: this.SortOrder,
                    SortProperty: this.SortProperty,
                },
                }
            ).then((res) => {
         
            // this.totalItems = res.data.totalCount || 0;
                let totalCount = res.data.totalCount;
                this.deviceList =res.data.results
                this.totalPages = parseInt(totalCount / this.pageSize);
                if (totalCount % this.pageSize != 0) {
                    this.totalPages = this.totalPages + 1;
                }
                this.showLoading=false
          
            }).catch((err)=> {
               this.showLoading=false
           console.error("Error fetching device details:", err);
            })
        },
        search() {
            this.currentPageNumber = 1;
            this.getDeviceDetails();
        },
        loadPage(page) {
            this.currentPageNumber = page;
            this.getDeviceDetails();
        },
       filter(data) {
             if (data) {
               return moment(data).format(this.defaultdate);
             }
           },
           toTime(data) {
             if (data) {
               return moment(data).format(this.defaultTime);
             }
           },
    SortSelected(sortProp, id) {
      const selectedElement = document.getElementById(id)
      const selectedElementID = document.getElementById(id).id
      if (sortProp != null && id == selectedElementID) {
        if (this.SortOrder == 0) {
          // if(selectedElement.classList.contains("sortDesc")){
          //   return
          // }
          if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc")
            selectedElement.classList.add("sortDesc")
          }
          else selectedElement.classList.add("sortDesc")
        }
        else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc")
            selectedElement.classList.add("sortAsc")
          }
          // else if(selectedElement.classList.contains("sortAsc"))
          // {
          //   return
          // }          
          else selectedElement.classList.add("sortAsc")
        }
      }
      this.currentPageNumber = 1;
      this.SortProperty = sortProp;
      this.SortOrder = this.SortOrder == 0 ? 1 : 0;
      this.getDeviceDetails();
    },
    },
};
